<template>
	<div class='ma-auto text-left' style='max-width: 700px' >
		<change-subscription-full-form  />
	</div>
</template>

<script>
import ChangeSubscriptionFullForm from './ChangeSubscriptionFullForm'

export default {
  components: {
    ChangeSubscriptionFullForm
  }
}
</script>
